export const cancelVoteTrasnaction = (setShowBallotModal) => {
    return () => {
      localStorage.removeItem("ratings");
      localStorage.removeItem("voteScore");
      setShowBallotModal(false);
    };
  };
  